import { create } from 'zustand'

interface EventSelectionState {
  selectedIds: Set<string>
  toggle: (id: string) => void
  select: (id: string) => void
  deselect: (id: string) => void
  selectMultiple: (ids: string[]) => void
  clear: () => void
  isSelected: (id: string) => boolean
  getSelectedIds: () => string[]
  count: () => number
}

export const useEventSelection = create<EventSelectionState>((set, get) => ({
  selectedIds: new Set<string>(),

  toggle: (id: string) => {
    set((state) => {
      const newSet = new Set(state.selectedIds)
      if (newSet.has(id)) {
        newSet.delete(id)
      } else {
        newSet.add(id)
      }
      return { selectedIds: newSet }
    })
  },

  select: (id: string) => {
    set((state) => {
      const newSet = new Set(state.selectedIds)
      newSet.add(id)
      return { selectedIds: newSet }
    })
  },

  deselect: (id: string) => {
    set((state) => {
      const newSet = new Set(state.selectedIds)
      newSet.delete(id)
      return { selectedIds: newSet }
    })
  },

  selectMultiple: (ids: string[]) => {
    set((state) => {
      const newSet = new Set(state.selectedIds)
      ids.forEach((id) => newSet.add(id))
      return { selectedIds: newSet }
    })
  },

  clear: () => {
    set({ selectedIds: new Set<string>() })
  },

  isSelected: (id: string) => {
    return get().selectedIds.has(id)
  },

  getSelectedIds: () => {
    return Array.from(get().selectedIds)
  },

  count: () => {
    return get().selectedIds.size
  },
}))
